var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.tier && _vm.data.tier.name && _vm.data.tier.name.length > 0)?_c('div',{staticClass:"profile-tag",class:_vm.className},[_vm._v("\n  "+_vm._s(_vm.data && _vm.data.tier ? _vm.data.tier.name : "")+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }